import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import Trainers from "./pages/trainers/trainers";
import AvailableTrainers from "./pages/trainers/AvailableTrainers";
import Students from "./pages/students/students";
import Support from "./pages/support/supports";
import Discounts from "./pages/discount/discounts";
import Login from "./common/auth";
import Notification from "./pages/notification/notification";
import InfoRequest from './pages/InfoRequest/InfoRequest';
import ManagerStudents from './pages/manager/ManagerStudents';
import Report from './pages/report/Report';
import SubscriptionReport from './pages/report/SubscriptionReport';
import MonthlyReport from './pages/report/MonthlyReport';
import MeetingTracking from './pages/report/MeetingTracking';
import Payroll from './pages/payroll/Payroll';
import SchoolAdd from './pages/school/SchoolAdd';
import SchoolBranches from './pages/school/SchoolBranches';
import SchoolStudents from './pages/school/SchoolStudents';
import SchoolFiles from './pages/school/SchoolFiles';
import SchoolOverview from './pages/school/SchoolOverview';
import VideoProvider from './pages/settings/VideoProvider';

function AllRoutes() {
  return (
    <Routes>
      <Route path="/">
        <Route path="login" element={<Login />} />
        <Route path="trainers" element={<Trainers />} />
        <Route path="available-trainers" element={<AvailableTrainers />} />
        <Route path="students" element={<Students />} />
        <Route path="supports" element={<Support />} />
        <Route path="discounts" element={<Discounts />} />
        <Route path="notification" element={<Notification />} />
        <Route path="infoRequest" element={<InfoRequest />} />
        <Route path="manager" element={<ManagerStudents />} />
        <Route path="report" element={<Report />} />
        <Route path="subscription-report" element={<SubscriptionReport />} />
        <Route path="monthly-report" element={<MonthlyReport />} />
        <Route path="meeting-tracking" element={<MeetingTracking />} />
        <Route path="video-provider" element={<VideoProvider />} />
        <Route path="payroll" element={<Payroll page="payroll" />} />
        <Route path="payroll/performance" element={<Payroll page="performance" />} />
        <Route path="school/add" element={<SchoolAdd />} />
        <Route path="school/branches" element={<SchoolBranches />} />
        <Route path="school/students" element={<SchoolStudents />} />
        <Route path="school/files" element={<SchoolFiles />} />
        <Route path="school/overview" element={<SchoolOverview />} />
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  );
}

function NoMatch() {
  return (
    <div>
      <h2>Page not found</h2>
      <p>
        <Link to="/">Back to home</Link>
      </p>
    </div>
  );
}

export default AllRoutes;
